import { X } from "lucide-react";
import { useEffect } from "react";

export function Modal({ open, onClose, title, children, testid, wide }) {
  useEffect(() => {
    const h = (e) => e.key === "Escape" && onClose();
    if (open) window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto p-4 sm:p-8"
      style={{ background: "rgba(0,0,0,.7)", backdropFilter: "blur(4px)" }}
      onClick={onClose}
      data-testid={testid ? `${testid}-overlay` : undefined}
    >
      <div
        className={`tm-card tm-fade w-full ${wide ? "max-w-4xl" : "max-w-lg"} my-8`}
        onClick={(e) => e.stopPropagation()}
        data-testid={testid}
      >
        <div className="flex items-center justify-between px-6 py-4" style={{ borderBottom: "1px solid var(--tm-border)" }}>
          <h3 className="font-display text-xl" style={{ color: "var(--tm-gold)" }}>{title}</h3>
          <button onClick={onClose} className="text-[var(--tm-muted)] hover:text-[var(--tm-beige)]" data-testid="modal-close">
            <X size={20} />
          </button>
        </div>
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <label className="block mb-4">
      <span className="block text-xs uppercase tracking-wider text-[var(--tm-muted)] mb-1.5">{label}</span>
      {children}
    </label>
  );
}
